export const APP_TIMEZONE = 'Asia/Kolkata';
export const APP_LOCALE = 'en-IN';
export const IST_OFFSET = '+05:30';

const DATE_OPTIONS = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: APP_TIMEZONE,
};

const DATE_TIME_OPTIONS = {
  ...DATE_OPTIONS,
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
  timeZone: APP_TIMEZONE,
};

const parseDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day));
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value, fallback = '—') => {
  const date = parseDate(value);
  if (!date) return fallback;
  return date.toLocaleDateString(APP_LOCALE, DATE_OPTIONS);
};

export const formatDateTime = (value, fallback = '—') => {
  const date = parseDate(value);
  if (!date) return fallback;
  return date.toLocaleString(APP_LOCALE, DATE_TIME_OPTIONS);
};

export const formatDisplayDate = (value) => {
  if (!value) return null;
  const formatted = formatDate(value, null);
  return formatted ?? value;
};

export const todayIsoDate = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: APP_TIMEZONE }).format(new Date());

export const toDayStart = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(`${dateStr}T00:00:00${IST_OFFSET}`);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const toDayEnd = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(`${dateStr}T23:59:59.999${IST_OFFSET}`);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const toIsoRangeStart = (dateStr) => toDayStart(dateStr)?.toISOString() ?? null;

export const toIsoRangeEnd = (dateStr) => toDayEnd(dateStr)?.toISOString() ?? null;

export const formatRelativeTime = (dateStr) => {
  if (!dateStr) return '';
  const date = parseDate(dateStr);
  if (!date) return '';

  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatDate(dateStr, '');
};
